import React, { PropsWithChildren } from 'react'
import classes from './FormHelperText.module.scss'
import clsx from 'clsx'

export type FormHelperTextProps = PropsWithChildren<{
  color?: 'neutral' | 'danger'
}>

const FormHelperText = ({ color = 'neutral', children }: FormHelperTextProps) => {
  const className = clsx(classes.root, {
    [classes.neutral]: color === 'neutral',
    [classes.danger]: color === 'danger',
  })

  return <div className={className}>{children}</div>
}

export default FormHelperText
